import { faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons';
import { useState } from 'react';

import DotNavigation from '@App/components/DotNavigation/DotNavigation';
import MaplibreMap from '@App/components/MaplibreMap/MaplibreMap';
import Markers from '@App/components/Markers/Markers';
import CaseStudySectionHeader from '@App/pages/CaseStudy/CaseStudySectionHeader/CaseStudySectionHeader';
import { useTranslation } from '@utils/i18n/i18n';

import './case-study-context.css';

function CaseStudyContext({
  locations,
  sectionClassName,
  mapCenter,
  mapZoom = 7,
  fitToMarkers = true,
  dotNavLabel = 'Location navigation',
  aboutIntro,
}) {
  const [selectedLocationId, setSelectedLocationId] = useState(locations[0].id);
  const { t } = useTranslation();
  const activeLocation = locations.find(l => l.id === selectedLocationId) ?? locations[0];
  const showDotNav = locations.length > 1;

  return (
    <div className={`case-study__section ${sectionClassName}`}>
      <div className="case-study-context__panel">
        <CaseStudySectionHeader icon={faMapMarkerAlt} label={t('Context')} />
        <div className="case-study-context__about">
          <MaplibreMap
            initialCenter={mapCenter ?? locations[0].coordinates}
            initialZoom={mapZoom}
            className="case-study-context__about__map"
          >
            <Markers
              selectedMarker={selectedLocationId}
              setSelectedMarker={showDotNav ? setSelectedLocationId : () => {}}
              markers={locations}
              fitToMarkers={fitToMarkers}
            />
          </MaplibreMap>
          <div className="case-study-context__about__content">
            <h2 className="case-study-context__title">{t('About')}</h2>
            {aboutIntro && <p className="case-study-context__paragraph">{t(aboutIntro)}</p>}
            {locations.map(location => (
              <div className="case-study-context__about__location" key={location.id}>
                {locations.length > 1 && (
                  <h3 className="case-study-context__about__location__subtitle">
                    {t(location.label)}
                  </h3>
                )}
                {location.aboutParagraphs.map(p => (
                  <p className="case-study-context__paragraph" key={p}>{t(p)}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="case-study-context__detail">
          <div className="case-study-context__detail__content">
            <h2 className="case-study-context__title">
              {t(activeLocation.challengesTitle)}
            </h2>
            <div className="case-study-context__detail__challenges">
              {activeLocation.challengesText}
            </div>
          </div>
          <div className="case-study-context__detail__media">
            <img
              alt={t(activeLocation.imageAlt)}
              className="case-study-context__detail__media__image"
              loading="lazy"
              src={activeLocation.imagePath}
            />
          </div>
          {showDotNav && (
            <DotNavigation
              ariaLabel={t(dotNavLabel)}
              activeId={activeLocation.id}
              className="case-study-context__detail__dots"
              items={locations}
              getItemAriaLabel={loc => loc.label}
              onSelect={setSelectedLocationId}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CaseStudyContext;
